
import Components from "./components/index"

const init = () => {
  Components.init()
}

export default {
  init,
}
